import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, CssBaseline } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';

import FuturaStdBoldTTF from 'fonts/FuturaStd/FuturaStd-Bold.ttf';
import FuturaStdBoldWOFF from 'fonts/FuturaStd/FuturaStd-Bold.woff';
import FuturaStdBoldWOFF2 from 'fonts/FuturaStd/FuturaStd-Bold.woff2';
import FuturaStdBoldOTF from 'fonts/FuturaStd/FuturaStd-Bold.otf';
import FuturaStdBookTTF from 'fonts/FuturaStd/FuturaStd-Book.ttf';
import FuturaStdBookOTF from 'fonts/FuturaStd/FuturaStd-Book.otf';
import FuturaStdBookWOFF from 'fonts/FuturaStd/FuturaStd-Book.woff';
import FuturaStdBookWOFF2 from 'fonts/FuturaStd/FuturaStd-Book.woff2';

const FuturaStdBold = {
  fontFamily: 'FuturaStdBold',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
    local('FuturaStd-Bold'),
    url(${FuturaStdBoldTTF}) format('ttf'),
    url(${FuturaStdBoldWOFF}) format('woff'),
    url(${FuturaStdBoldWOFF2}) format('woff2'),
    url(${FuturaStdBoldOTF}) format('otf')
  `,
};
const FuturaStdBook = {
  fontFamily: 'FuturaStdBook',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
    local('FuturaStd-Book'),
    url(${FuturaStdBookTTF}) format('ttf'),
    url(${FuturaStdBookOTF}) format('otf'),
    url(${FuturaStdBookWOFF}) format('woff'),
    url(${FuturaStdBookWOFF2}) format('woff2')
  `,
};


const theme = createTheme({
  palette: {
    primary: { main: '#5ac8f5' },
    secondary: { main: '#e84249' },
    info: { main: '#fff' },
    background: { default: '#f8f5f9' },
    error: { main: '#e84249' },
  },
  containerGrid: {
    marginTop: '.5rem',
    flexGrow: 1,
    //'-webkit-overflow-scrolling': 'touch'
  },
  title: {
    margin: 0,
    color: '#262957',
    fontSize: '20px',
    fontWeight: 700,
    fontFamily: ['FuturaStdBold', 'sans-serif'].join(','),
  },
  subTitle: {
    margin: 0,
    color: '#262957',
    fontSize: '17px',
    fontWeight: 500,
    fontFamily: ['FuturaStdBook', 'sans-serif'].join(','),
  },
  subTitle2: {
    margin: 0,
    color: '#262957',
    fontSize: '16px',
    fontWeight: 500,
    fontFamily: ['FuturaStdBook', 'sans-serif'].join(','),
  },
  labelButton: {
    fontSize: '18px',
    fontWeight: 400,
    fontFamily: ['FuturaStdBook', 'sans-serif'].join(','),
    padding: '.3rem, 1rem',
  },
  typography: {
    color: '#262957',
    fontFamily: ['Nunito Sans', 'Arial', 'sans-serif'].join(','),
    fonteight: 600
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [
          FuturaStdBold,
          FuturaStdBook,
        ],
      },
    },
  },
  containerError: {
    background: '#e84249',
    padding: '.5rem',
    borderRadius: '12px',
    textAlign: 'center',
    '& p': {
      color: '#fff',
      fontWeight: '600',
      fontFamily: ['FuturaStdBook', 'sans-serif'].join(','),
    },
  },
});
const themeName = 'Laddition';
export const ThemeProviderCustomize = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  );
};
